import $          from 'jquery';
import cx         from 'classnames';
import React      from 'react';
import ReactDOM   from 'react-dom';
import Utils      from 'medscape/utils';
export default class DiscussionIntroductionField extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {

    if(this.props.type==0 || this.props.content==null){
      return null;
    }

    let classes = cx({
      "discussion-content": this.props.type==DiscussionIntroductionField.types.DISCUSSION,
      "introduction-content": this.props.type==DiscussionIntroductionField.types.INTRODUCTION
    })

    let pProps = {
      className: classes,
      dangerouslySetInnerHTML: Utils.getDangerousHtml(this.props.content)
    }
    return(
      <div className="discission-introduction-field-component">
        <p {...pProps} />
      </div>
    )
  }
}
DiscussionIntroductionField.propTypes={
  type: React.PropTypes.number,
  content: React.PropTypes.string
}
DiscussionIntroductionField.defaultProps={
  content: "",
  type: 0
}
DiscussionIntroductionField.types = {
  DISCUSSION: 1,
  INTRODUCTION: 2
}


// WEBPACK FOOTER //
// ./medscape_modules/qna/form-components/discussion-introduction-field.jsx